import BaseAPI from './base.api';

export default class FuelPriceAPI extends BaseAPI {
  get = async () => {
    const response = await this.API.get(`fuel-price`);
    return response.data;
  };
}
